import { FuiHeadingComponent } from "./heading/heading.component";
import { FuiCardComponent } from "./card/card.component";
import { FuiFooterComponent } from "./footer/footer.component";
import { FuiContentFilterComponent } from "./content-filter/content-filter.component";
import { FuiLayoutHeaderComponent } from "./layout-header/layout-header.component";
import { FuiSidebarFilterComponent } from "./sidebar-filter/sidebar-filter.component";
import { FuiFilterContentComponent } from "./filter-content/filter-content.component";

export const FENDERUI_COMPONENTS = [
  FuiHeadingComponent,
  FuiCardComponent,
  FuiFooterComponent,
  FuiContentFilterComponent,
  FuiLayoutHeaderComponent,
  FuiSidebarFilterComponent,
  FuiFilterContentComponent,
];

export * from "./heading/heading.component";
export * from "./card/card.component";
export * from "./footer/footer.component";
export * from "./content-filter/content-filter.component";
export * from "./layout-header/layout-header.component";
export * from "./sidebar-filter/sidebar-filter.component";
export * from "./filter-content/filter-content.component";
